/*  src/pages/forgotpassword.jsx  */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import isEmail from "validator/lib/isEmail";
import { toast } from "react-hot-toast";
import { AiOutlineLeft } from "react-icons/ai";
import { apiInstance } from "../config/apiConfig";

import "../sass/homepage.scss";
import "../sass/forgotpassword.scss";

/* helper → fresh id for every click so duplicates are never suppressed */
const newToastId = () => `toast-${Date.now()}-${Math.random()}`;

export default function Forgotpassword() {
  const nav = useNavigate();

  const [emailId, setEmailId] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp,     setOtp]     = useState("");

  /* SEND / RESEND OTP -------------------------------------------------- */
  const handleSendOtp = async () => {
    if (!isEmail(emailId)) return toast.error("Enter a valid e-mail address");

    const id = newToastId();
    toast.promise(
      apiInstance.post("/api/otp/send-reset-otp", { email: emailId }),
      {
        loading : "Sending reset code…",
        success : "OTP sent — check your inbox",
        error   : err => err?.response?.data?.message || "Failed to send OTP",
      },
      { id }          // id is both toastId & update target
    ).then(() => setOtpSent(true));
  };

  /* VERIFY OTP --------------------------------------------------------- */
  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return toast.error("Enter the 6-digit OTP");

    const id = newToastId();
    toast.promise(
      apiInstance.post("/api/otp/verify-otp", { email: emailId, otp }),
      {
        loading : "Verifying…",
        success : "OTP verified! Redirecting…",
        error   : err => err?.response?.data?.message || "Verification failed",
      },
      { id }
    ).then(() => nav("/resetpassword", { state: { emailId } }));
  };

  /* JSX ---------------------------------------------------------------- */
  return (
    <section id="body">
      <div className="forgotpassword">
        <div className="flex justify-center items-center h-screen">
          <div className="card w-96 bg-base-100 shadow-xl p-5">
            <div className="card-body">

              {/* header */}
              <div className="button-container">
                <button onClick={() => nav("/login")} className="back-button text-xl font-bold icon-align">
                  <AiOutlineLeft />
                </button>
                <button onClick={() => nav("/login")} className="signup-button">
                  Login
                </button>
              </div>

              {/* step 1 – e-mail */}
              {!otpSent ? (
                <>
                  <label className="label"><h2>Email Address</h2></label>
                  <input
                    type="email"
                    className="input input-bordered"
                    value={emailId}
                    onChange={e => setEmailId(e.target.value)}
                  />
                  <button className="secondary-button mt-6" onClick={handleSendOtp}>
                    Send OTP
                  </button>
                </>
              ) : (
              /* step 2 – OTP */
                <>
                  <label className="label"><h2>Enter OTP</h2></label>
                  <input
                    type="text"
                    className="input input-bordered"
                    maxLength="6"
                    value={otp}
                    onChange={e => setOtp(e.target.value)}
                  />
                  <button className="secondary-button mt-6" onClick={handleVerifyOtp}>
                    Verify OTP
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
